import { Language, ViewResponse } from '@yleisradio/areena-types';
import { fetchItemView } from '../fetchers';
import { useAppFeaturesContext } from '../../../client/contexts/AppFeaturesContext/AppFeaturesContext';
import useSWRImmutable from 'swr/immutable';

type RequestKey = [itemId: string, language: Language];

async function fetcher([itemId, language]: RequestKey): Promise<ViewResponse> {
  return fetchItemView(itemId, language);
}

export function useFetchItem(itemId: string | undefined) {
  const { languageCode } = useAppFeaturesContext();

  const { data, isLoading } = useSWRImmutable(
    itemId ? ([itemId, languageCode] satisfies RequestKey) : null,
    fetcher
  );

  return { data, isLoading };
}
